<template>
    <div>
        <page-header title="لیست دسته بندی ها" create-url="/categories/create"></page-header>

        <search-filter :filters="filters" @search="search"></search-filter>

        <table-with-pagination v-if="categories"
                               :items="categories"
                               :headers="headers"
                               :default-page="parseInt($route.query.page ?? '1')"
                               @fetchPage="getCategories"
                               @delete="deleteCategory"
                               :actions="actions"
        ></table-with-pagination>
    </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import TableWithPagination from "@/components/General/TableWithPagination";
import SearchFilter from "@/components/General/SearchFilter.vue";

export default {
    name: "CategoriesList",

    components: {SearchFilter, TableWithPagination, PageHeader},

    data() {
        return {
            headers: [
                {text: 'شناسه', value: 'id', align: 'center'},
                {text: 'نام فارسی', value: 'fa_name', align: 'center'},
                {text: 'نام انگلیسی', value: 'en_name', align: 'center'},
                {text: 'عکس', value: 'image_url', align: 'center'},
                {text: 'دسته والد', value: 'parent', align: 'center'},
                {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
                {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
                {text: 'عملیات', value: 'actions', align: 'center'},
            ],

            categories: null,

            actions: [
                {
                    icon: 'mdi-pencil',
                    color: 'warning',
                    route_name: 'update-category',
                    route_param: 'fa_slug'
                },
                {
                    icon: 'mdi-delete',
                    color: 'error',
                    emit: 'delete',
                    identifier: 'fa_slug',
                    delete_confirm: true,
                }
            ],

            filters: [],
            searchValues: '',
            allCategories: []
        }
    },

    mounted() {
        this.getCategories(parseInt(this.$route.query.page ?? "1"))
        this.getAllCategories()
    },

    methods: {
        search(values) {
            this.$store.dispatch("objectParametersToString", values).then((result) => {
                this.searchValues = result
                this.getCategories()
            })
        },

        getCategories(page = 1) {
            this.$store.dispatch("getPaginatedCategories", page + this.searchValues)
                .then((res) => {
                    this.categories = res.data
                })
        },

        getAllCategories() {
            this.$store.dispatch("getAllCategories")
                .then((res) => {
                    this.allCategories = res.data
                    this.fillFilters()
                })
        },

        fillFilters() {
          this.filters = [
              {
                  type: 'text',
                  name: 'needle',
                  label: 'جستجو',
              },
              {
                  type: 'select',
                  name: 'parent_category_id',
                  label: 'دسته بندی والد',
                  select_text: 'fa_name',
                  select_value: 'id',
                  select_items: this.allCategories,
              },
          ]
        },

        deleteCategory(slug) {
            this.$store.dispatch("deleteCategory", slug)
                .then(() => {
                    this.getCategories(this.categories.pagination.current_page)
                })
        }
    }
}
</script>

<style scoped>

</style>